<template>
    <div class="col-12">
        <div class="col-12" v-for="file in filesForDownload" :key="'file'+file.id">
            <file-download v-if="file.id" :file="file"></file-download>
        </div>

        <vs-upload
            ref="fileSelector"
            :key="uploadKey"
            :text="$t('addFile')"
            :showUploadButton="false"
            @change="fileChanged"
            @on-delete="fileRemoved">
        </vs-upload>

        <transition-group name="fileDescriptionAnimation" enter-active-class="animated zoomInDown" leave-active-class="animated zoomOutUp" class="col-12">
            <!--pulse-->
            <!--<div class="col-12 mt-2 border border-secondary rounded fileDescription"
                 v-for="file in model"
                 :key="file.fileName">
                <label>{{ file.fileName }}</label>
                <div><input class="form-control" :placeholder="$t('description')" v-model="file.fileDescription" /></div>
            </div>-->
        </transition-group>
    </div>
</template>

<script>
    import { File as FileModel } from '../../models/file.models';
    import FileDownload from '../common/FileDownload';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            value: String,
            model: Array,
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            }
        },
        components: {
            FileDownload
        },
        data() {
            return {
                filesForDownload: [],
                activePrompt: false,
                originalModel: [],
                files: [],
                uploadKey: 0
            };
        },
        computed: {
            ...mapGetters(['fileSizeLimit']),
        },
        methods: {
            fileChanged() {
                let file = this.$refs.fileSelector.$refs.fileInput.files[0];

                if (file) {
                    if (file.size > this.fileSizeLimit) { // 10 MB
                        this.$vs.notify({
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.fileSizeLimitExceeded', { maxSize: this.fileSizeLimit / 1048576 }),
                            color: 'danger',
                        });
                        // Force re-render of the upload component by changing its key
                        this.uploadKey++;
                        return;
                    }
                    let fileModel = new FileModel({
                        fileName: file.name,
                        content: file,
                        fileDescription: ''
                    });
                    this.files.push(fileModel);
                    this.saveAsTempFile(fileModel);
                }
            },
            fileRemoved(fileToRemove) {
                const indexToDelete = this.files.findIndex(
                    x => x.fileName === fileToRemove.fileName
                );
                if (
                    indexToDelete >= 0 &&
                    Array.isArray(this.model) &&
                    this.model.length > 0
                ) {
                    this.model = this.model.splice(indexToDelete, 1);
                }
                if (
                    indexToDelete >= 0 &&
                    Array.isArray(this.files) &&
                    this.files.length > 0
                ) {
                    this.files = this.files.splice(indexToDelete, 1);
                }

                this.$emit('fileRemoved', fileToRemove);
            },
            getSeparatedFileNames() {
                let fileNames = [];
                this.model.forEach(file => {
                    fileNames.push(file.fileName);
                });

                return fileNames.join('|');
            },
            async saveAsTempFile(fileModel) {
                try {
                    if (fileModel) {
                        let formData = new FormData();
                        formData.append(
                            'files',
                            fileModel.content,
                            fileModel.fileName
                        );
                        const result = await this.$http.post(
                            `/api/TempFile/add`,
                            formData
                        );
                        if (result) {
                            let tempFileId = result.data.tempFileId;
                            if (tempFileId) {
                                fileModel.tempId = tempFileId;
                                this.model.push(fileModel);
                            } else {
                                this.fileRemoved(fileModel);
                            }
                        } else {
                            this.fileRemoved(fileModel);
                        }
                    }
                } catch (error) {
                    this.fileRemoved(fileModel);
                }
            },
            clearFiles() {
                if (this.files && this.files.length > 0) {
                    while (this.files.length > 0) { this.files.pop(); }
                }
            }
        },
        mounted() {
        }
    };
</script>
